import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Tour } from 'src/classes/tour';
import { AuxService } from '../aux.service';

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.css'],
  standalone: false,
})
export class TourComponent {
  constructor(
    private router: Router,
    private aux: AuxService,
  ) {}

  @Input() tour: Tour;

  redirectArticle() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([
        '/tour/' +
          this.tour.id +
          '-' +
          this.aux.slugify(this.tour.name) +
          '/article/' +
          this.tour.articles[0].resumo,
      ]);
    });
  }
}
